import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import './editar-evento.scss'
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
  Stack,
  Checkbox,
  Spinner,
  Alert,
  AlertIcon,
  AlertDescription,
  AlertTitle,
  Wrap,
  TagCloseButton,
  Tag,
  WrapItem,
  TagLabel,
  Switch,
  HStack
} from '@chakra-ui/react';
import { ImageDropzone } from '../../../PublishContent/components/Banner/imageDropzone';
import { FileWithPath } from 'react-dropzone';
import * as api from '../../../../api/evento';
import CustomTextArea from '../../../../components/common/Textarea/textArea';
import Swal from 'sweetalert2';
import { listarCategoriasAtivas } from '../../../../api/categoria';
import { obterUsuario } from '../../../../api/usuario';
import { PublicacaoParams } from '../../../../interfaces/publicacao.interface';
import { FaPlus } from 'react-icons/fa';
import { deletarSecretariaAssociada, listarSecretariasAtivas } from '../../../../api/secretarias';

const EditarEvento: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    data: { value: typeof today; error: boolean };
    dataFim: { value: ''; error: boolean };
    dataInicioEvento: { value: ''; error: boolean };
    dataFimEvento: { value: ''; error: boolean };
    numSemHorario: { value: boolean; error: boolean };
    horaInicioEvento: { value: ''; error: boolean };
    horaFimEvento: { value: ''; error: boolean };
    imagem: { value: string; error: boolean };
    dscResumo: { value: string; error: boolean };
    secretariaId: { value: any[]; error: boolean };
    enderecoInternet: { value: string; error: boolean };
    endereco: { value: string; error: boolean };
    creditoAutorNoticia: { value: string; error: boolean };
    creditoAutorImagem: { value: string; error: boolean };
    descricaoImagem: { value: string; error: boolean };
    altImagem: { value: string; error: boolean };
    texto: { value: string; error: boolean };
    seqCategoria: { value: any; error: boolean };
    paginaId: { value: any[]; error: boolean };
    usuarioId: { value: any; error: boolean };
    exigeAprovacao: { value: number; error: boolean };

  }>({
    titulo: { value: '', error: false },
    data: { value: today, error: false },
    dataFim: { value: '', error: false },
    dataInicioEvento: { value: '', error: false },
    dataFimEvento: { value: '', error: false },
    numSemHorario: { value: false, error: false },
    horaInicioEvento: { value: '', error: false },
    horaFimEvento: { value: '', error: false },
    imagem: { value: '', error: false },
    dscResumo: { value: '', error: false },
    secretariaId: { value: [], error: false },
    enderecoInternet: { value: '', error: false },
    endereco: { value: '', error: false },
    creditoAutorNoticia: { value: '', error: false },
    creditoAutorImagem: { value: '', error: false },
    descricaoImagem: { value: '', error: false },
    altImagem: { value: '', error: false },
    texto: { value: '', error: false },
    seqCategoria: { value: '', error: false },
    paginaId: { value: [], error: false },
    usuarioId: { value: null, error: false },
    exigeAprovacao: { value: 0, error: false },
  });

  const [imageBase64, setImageBase64] = useState<string>('');
  const [paginas, setPaginas] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [temporaryTexto, setTemporaryTexto] = useState<string>('');
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [removedPages, setRemovedPages] = useState<number[]>([]);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [secretarias, setSecretarias] = useState<any[]>([]);
  const [secretariaSelecionada, setSecretariaSelecionada] = useState<number[]>([]);
  const [secretariasRemovidas, setSecretariasRemovidas] = useState<number[]>([]);
  const [arquivo, setArquivo] = useState<any>();
  const [arquivoSelecionado, setArquivoSelecionado] = useState<File | null>(null);
  const [nomeCdn, setNomeCdn] = useState<any>(null);
  const [imagePreview, setImagePreview] = useState<string>("");
  const [temImagem, setTemImagem] = useState<boolean>(false)
  const [isLoadingButton, setLoadingButton] = useState<boolean>(false);
  const [isAtivo, setIsAtivo] = useState<number>(1);
  const [inputValueTagUsuario, setInputValueTagUsuario] = useState('');
  const [tagUsuario, setTagUsuario] = useState<string>('');
  const [getCodSituacaoPubli, setgetCodSituacaoPubli] = useState<number>(1);
  const [motivosReprovacao, setMotivosReprovacao] = useState('');
  const [getObjPendencia, setgetObjPendencia] = useState<any>();

  const fetchEventoData = async () => {
    setIsLoading(true);
    try {
      const EventoData = await api.obterEvento(Number(id));
      const {
        nomePublicacao,
        datPublicacao,
        datDespublicar,
        datInicioEvento,
        datFimEvento,
        dscCreditoImagem,
        dscCreditoNoticia,
        dscAltImagem,
        dscDescricaoImagem,
        seqCategoria,
        conteudoSecretariaDTO,
        conteudoPaginaDTO,
        binPublicacao,
        urlBin,
        dscEnderecoEvento,
        dscResumo,
        dscPublicacao,
        dscHoraInicioEvento,
        dscHoraFimEvento,
        numSemHorario,
        pendencia,
        numRegistro,
        dscCitacaoUsuario,
        codSituacaoPubli
      } = EventoData;

      const selecionadas = (conteudoSecretariaDTO ?? []).map((i: any) => Number(i.codSecretaria));

      if(EventoData.numRegistro == 0) {
        setIsAtivo(0)
      }

      if (EventoData.codSituacaoPubli) {
        setgetCodSituacaoPubli(EventoData.codSituacaoPubli)
      }

      if (EventoData.pendencia) {
        setgetObjPendencia(EventoData.pendencia)
      }

      const userTagsArray = (dscCitacaoUsuario || '')
        .split(' ')
        .filter((tag: any) => tag.startsWith('@'));
      setTagUsuario(userTagsArray.join(' '));
  
      let exigeAprovacaoValue = 0;
      if (pendencia && pendencia.seqSolicitante) {
        exigeAprovacaoValue = 1;
      }

      if (pendencia && pendencia.dscObs) {
        setMotivosReprovacao(pendencia.dscObs);
      }

      const usuarioIdValue = pendencia?.seqExecutor;
  
      let imagemFormValue = "";
      let imagePreviewValue = "";
      let nomeCdnValue = "";
  
      if (binPublicacao && binPublicacao.trim() !== "") {
        setTemImagem(true);
        
        imagemFormValue = binPublicacao;
        imagePreviewValue = atualizarPreview(binPublicacao);
  
        const delimiter = "%2F";
        const index = binPublicacao.lastIndexOf(delimiter);
        nomeCdnValue =
          index !== -1 ? binPublicacao.substring(index + delimiter.length) : binPublicacao;
        setNomeCdn(nomeCdnValue);
        
        setImagePreview(imagePreviewValue);
      } else {
        setTemImagem(false);
      }
  
      setFormValues({
        titulo: { value: nomePublicacao, error: false },
        data: { value: datPublicacao || today, error: false },
        dataFim: { value: datDespublicar || '', error: false },
        dataInicioEvento: { value: datInicioEvento || '', error: false },
        dataFimEvento: { value: datFimEvento || '', error: false },
        horaInicioEvento: { value: dscHoraInicioEvento || '', error: false },
        horaFimEvento: { value: dscHoraFimEvento || '', error: false },
        numSemHorario: { value: numSemHorario, error: false },
        imagem: { value: imagemFormValue, error: false },
        endereco: { value: dscEnderecoEvento || '', error: false },
        creditoAutorImagem: { value: dscCreditoImagem || '', error: false },
        descricaoImagem: { value: dscDescricaoImagem || '', error: false },
        altImagem: { value: dscAltImagem || '', error: false },
        seqCategoria: { value: seqCategoria || '', error: false },
        paginaId: { value: conteudoPaginaDTO.map((item: any) => item.seqPagina.toString()), error: false },
        secretariaId: { value: selecionadas, error: false },
        usuarioId: { value: usuarioIdValue, error: false },
        exigeAprovacao: { value: exigeAprovacaoValue, error: false },
        dscResumo: { value: dscResumo || '', error: false },
        enderecoInternet: { value: urlBin || '', error: false },
        creditoAutorNoticia: { value: dscCreditoNoticia || '', error: false },
        texto: { value: dscPublicacao || '', error: false },
      });

      setSecretariaSelecionada(selecionadas);

      
    } catch (error) {
      console.error("Erro ao buscar dados do evento:", error);
    } finally {
      setIsLoading(false);
    }
  };  

  const fetchPaginas = async () => {
    try {
      const data = await api.paginasAtivas();
      setPaginas(data);
    } catch (error) {
      console.error('Erro ao buscar páginas ativas:', error);
    }
  };

  const fetchAprovadoresAtivos = async () => {
    try {
      const data = await api.listarExecutores();
    } catch (error) {
      console.error('Erro ao buscar lista de executores para aprovação:', error);
    }
  };

  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);
        
        const fetchObterUsuario = async () => {
          try {
           const [data, ativas] = await Promise.all([
             obterUsuario(Number(usuario.seqUsuario)),
             listarSecretariasAtivas()
           ]);
           setSecretarias(
            data.usuarioSecretariaDTO?.length ? data.usuarioSecretariaDTO : ativas
          );
          } catch (error) {
            console.error("Erro ao obter usuario:", error);
          }
        };
  
        fetchObterUsuario();
  
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }

    const fetchCategorias = async () => {
      try {
        const data = await listarCategoriasAtivas();
        setCategorias(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };

    fetchCategorias();
    fetchEventoData();
    fetchPaginas();
    fetchAprovadoresAtivos();
  }, []);

  const handleDeletePages = async () => {
    try {
      for (const seqPagina of removedPages) {
        await api.deletarRelacionamentoPagina(Number(id), seqPagina);
      }

      setRemovedPages([]);
    } catch (error) {
      console.error('Erro ao remover páginas:', error);
    }
  };

  const handleDeleteSecretarias = async () => {
    try {
      for (const codSecretaria of secretariasRemovidas) {
        await deletarSecretariaAssociada(codSecretaria, Number(id));
      }

      setSecretariasRemovidas([]);
    } catch (error) {
      console.error('Erro ao remover páginas:', error);
    }
  };

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const handleCheckboxSecretaria = (codSecretaria: number, checked: boolean) => {
    setSecretariaSelecionada(prev => {
      const next = checked
        ? Array.from(new Set([...prev, codSecretaria]))
        : prev.filter(id => id !== codSecretaria);
      return next;
    });

    setSecretariasRemovidas(prev =>
      checked
        ? prev.filter(id => id !== codSecretaria)
        : Array.from(new Set([...prev, codSecretaria]))
    );

    setFormValues((prev: any) => {
      const current: number[] = Array.isArray(prev?.secretariaId?.value) ? prev.secretariaId.value : [];
      const next = checked
        ? Array.from(new Set([...current, codSecretaria]))
        : current.filter(id => id !== codSecretaria);

      return {
        ...prev,
        secretariaId: { ...prev.secretariaId, value: next, error: prev?.secretariaId?.error ?? false },
      };
    });
  };

  const handleAddTagUsuario = () => {
    if (inputValueTagUsuario.trim()) {
      setTagUsuario((prevTagUsuario) =>
        prevTagUsuario ? `${prevTagUsuario} ${inputValueTagUsuario.trim()}` : inputValueTagUsuario.trim()
      );
      setInputValueTagUsuario('');
    }
  };

  const handleRemoveTagUsuario = (tagToRemove: string) => {
    setTagUsuario((prevTagUsuario) => {
      const updatedTags = prevTagUsuario
        .split(' ')
        .filter((tag) => tag !== tagToRemove)
        .join(' ');
      return updatedTags.trim();
    });
  };

  const handleInputChangeTagUsuario = (e: any) => {
    const value = e.target.value;

    const valueWithoutSpaces = value.replace(/\s/g, '');
    if (valueWithoutSpaces && !valueWithoutSpaces.startsWith('@')) {
      setInputValueTagUsuario(`@${valueWithoutSpaces}`);
    } else {
      setInputValueTagUsuario(valueWithoutSpaces);
    }
  };

  const handleCheckboxChange = (seqPagina: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setRemovedPages(prev => prev.filter(id => id !== seqPagina));
    } else {
      setRemovedPages(prev => [...prev, seqPagina]);
    }

    setFormValues((prevValues: any) => {
      const updatedPaginaIdValue = isChecked
        ? [...prevValues.paginaId.value, seqPagina.toString()]
        : prevValues.paginaId.value.filter((id: string) => id !== seqPagina.toString());

      return {
        ...prevValues,
        paginaId: { value: updatedPaginaIdValue },
      };
    });
  };

  const atualizarPreview = (url: string): string => {
    if (url.startsWith("data:")) {
      return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}t=${new Date().getTime()}`;
  };  

  const handleImageSelected = async (selecionado: FileWithPath | null) => {
    if (selecionado) {
      const isImagem = selecionado.type.startsWith("image/");
      const isVideo = selecionado.type.startsWith("video/");
      const isAudio = selecionado.type.startsWith("audio/");

      setArquivo(selecionado);

      if (isImagem || isVideo || isAudio) {
        setArquivoSelecionado(selecionado);
        setArquivo(selecionado);
      } else {
        console.error("Tipo de arquivo não suportado.");
      }
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === "string") {
          const novaUrl = atualizarPreview(reader.result);
          setImagePreview(novaUrl);
          setFormValues((prev) => ({
            ...prev,
            imagem: { value: novaUrl, error: false },
          }));
        }
      };
      reader.readAsDataURL(selecionado);
    } else {
      setArquivo(null);
      setArquivoSelecionado(null);
      console.warn("Nenhum arquivo selecionado.");
    }
  };  

  const isFormValid = () => {
    const {
      titulo,
      data,
      dataInicioEvento,
      horaInicioEvento,
      horaFimEvento,
      seqCategoria,
      paginaId,
      usuarioId,
      exigeAprovacao,
      numSemHorario
    } = formValues;
  
    if (exigeAprovacao.value === 1 && !usuarioId.value) {
      return false;
    }
  
    const horarioValido =
      numSemHorario.value ||
      (horaInicioEvento.value && horaFimEvento.value);
  
    const isValid =
      Boolean(titulo.value) &&
      Boolean(data.value) &&
      Boolean(dataInicioEvento.value) &&
      horarioValido &&
      Boolean(seqCategoria.value) &&
      paginaId.value.length > 0 &&
      (exigeAprovacao.value === 0 || usuarioId.value != null);
  
    return isValid;
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoadingButton(true);

    await handleDeletePages();
    await handleDeleteSecretarias();

    const { endereco, enderecoInternet, texto, creditoAutorImagem, creditoAutorNoticia, dataFim, dataInicioEvento, dataFimEvento, seqCategoria, paginaId, secretariaId, usuarioId, horaInicioEvento, horaFimEvento, numSemHorario, data, imagem } = formValues;

    const pendencia = usuarioId.value
      ? {
        codPendencia: 1,
        seqSolicitante: seqUsuario,
        seqExecutor: usuarioId.value,
      }
      : null;

      if(getCodSituacaoPubli == 6) {
        getObjPendencia['codPendencia'] = 1;
      }
  
      let codSituacao = 1;
  
      if (data.value) {
        const dataDaPublicacao = data.value;
        const diaDeHoje = new Date().toISOString().split("T")[0];
  
        if (getObjPendencia) {
          codSituacao = 5;
        } else if (dataDaPublicacao > diaDeHoje) {
          codSituacao = 1;
        } else if (dataDaPublicacao === diaDeHoje) {
          codSituacao = 2;
        }  
      } else {
        codSituacao = 2;
      }

    const eventoDiaInteiro = formValues.numSemHorario.value;

    const horaInicio = eventoDiaInteiro
      ? null
      : formValues.horaInicioEvento.value || null;

    const horaFim = eventoDiaInteiro
      ? null
      : formValues.horaFimEvento.value || null;

      const params: PublicacaoParams = {
        seqConteudo: Number(id),
        codTipoPublicacao: 2,
        codSituacaoPubli: codSituacao,
        numRegistro: isAtivo,
        nomePublicacao: formValues.titulo.value || null,
        datPublicacao: formValues.data.value ? formValues.data.value : null,
        datDespublicar: dataFim.value ? formValues.dataFim.value : null,
        datInicioEvento: dataInicioEvento.value || null,
        datFimEvento: dataFimEvento.value || null,
        dscHoraInicioEvento: horaInicio,
        dscHoraFimEvento: horaFim,
        numSemHorario: eventoDiaInteiro ? 1 : 0,
        seqUsuario: seqUsuario,
        binPublicacao: imagem.value || '',
        dscCitacaoUsuario: tagUsuario,
        dscResumo: formValues.dscResumo.value || null,
        urlBin: enderecoInternet.value || null,
        dscEnderecoEvento: endereco.value || null,
        dscPublicacao: texto.value || null,
        dscCreditoImagem: creditoAutorImagem.value || null,
        dscCreditoNoticia: creditoAutorNoticia.value || null,
        dscAltImagem: formValues.altImagem.value || null,
        dscDescricaoImagem: formValues.descricaoImagem.value || null,
        seqCategoria: Number(seqCategoria.value) || null,
        pendencia: getObjPendencia || null,
        numAprovacao: pendencia ? 1 : 0,
        conteudoPaginaDTO: paginaId.value.map((id: any) => {
          return {
            seqPagina: Number(id),
            numOrdem: 0,
            datFim: dataFim.value ? formValues.dataFim.value : null,
          };
        }),
        dscTags: null,
        numAprovado: 0,
        contasRedeSocial: null,
        conteudoSecretariaDTO: secretariaId.value.map((id: number) => ({
          codSecretaria: id,
        })),
      };

    try {
      if (arquivoSelecionado && temImagem) {
        const formData = new FormData();
        const nomePasta = 'publicacoes';
        const nomeArquivo = nomeCdn || "evento";
        
        formData.append('file', arquivoSelecionado);
        formData.append('fileName', nomeArquivo);
        formData.append('folderName', nomePasta);

        const cdnData = await api.editarEventoNoCdn(formData);
        let cdnUrl = "";
        
        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }
        
        params.binPublicacao = cdnUrl;
      }
      if (arquivoSelecionado && !temImagem) {
        const formData = new FormData();

        const fileExtension = arquivoSelecionado.name.split('.').pop();
        let fileNameToSend = 'evento';

        if (
          fileExtension &&
          !fileNameToSend.toLowerCase().endsWith(`.${fileExtension.toLowerCase()}`)
        ) {
          fileNameToSend = `${fileNameToSend}.${fileExtension}`;
        }

        const nomePasta = 'publicacoes';
        const nomeArquivo = nomeCdn || 'evento';
        
        formData.append('file', arquivoSelecionado);
        formData.append('fileName', nomeArquivo);
        formData.append('folderName', nomePasta);
        const cdnData = await api.inserirEventoNoCdn(formData);
        let cdnUrl = "";
        
        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }
        
        params.binPublicacao = cdnUrl;
      }

      await api.editarPublicacao(id, params);
      setLoadingButton(false);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Evento editado com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate(-1);
      });
    } catch (error) {
      setLoadingButton(false);
      console.error('Erro ao editar evento:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao editar evento. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate(-1);
      });
    }
  };

  const inativarPublicacao = async () => {     
    if(getCodSituacaoPubli == 6) {
      getObjPendencia['codPendencia'] = 3;
    }

    Swal.fire({
      title: 'Tem certeza?',
      text: "Certeza que deseja inativar imediatamente a Publicação?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1789FC',
      cancelButtonColor: '#EDF2F7',    
      confirmButtonText: 'Sim, inativar',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const params = {
          pendencia: getObjPendencia || null,
          seqUsuario: seqUsuario,
          numRegistro: 0,
          codSituacaoPubli: 3
        };
  
        try {
          await api.editarPublicacao(id, params);
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: 'Evento inativado com sucesso.',
            confirmButtonColor: '#1789FC',
            confirmButtonText: 'OK',
          }).then(() => {
            navigate(-1);
          });
        } catch (error) {
          console.error('Erro ao inativar evento:', error);
          Swal.fire({
            icon: 'error',
            title: 'Ocorreu um erro!',
            text: 'Erro ao inativar evento. Tente novamente mais tarde.',
            confirmButtonColor: '#1789FC',
            confirmButtonText: 'OK',
          }).then(() => {
            navigate(-1);
          });
        }
      }
    });
  };  

  const mostrarMotivoReprovacao = () => {
    const texto = motivosReprovacao || 'Motivos não informados.';
    const isTextoLongo = texto.length > 150;
  
    Swal.fire({
      title: 'Motivos da Reprovação',
      width: isTextoLongo ? '50%' : undefined,
      html: `<div style="max-height: 250px; overflow-y: auto;">
              <p>${texto}</p>
            </div>`,
      icon: 'warning',
      confirmButtonColor: '#1789FC',
      confirmButtonText: 'Entendi'
    });
  };  

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      < SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Editar Evento
      </Heading>
      {isAtivo == 0 && (
        <Flex justifyContent="end">
          <Alert status="error" mt="35px" borderRadius="md">
            <AlertIcon />
            <Box flex="1">
              <AlertTitle fontSize="lg" mb={1}>Publicação Inativada</AlertTitle>
              <AlertDescription display="block">
                Este evento foi permanentemente inativado e não poderá ser reativado.
              </AlertDescription>
            </Box>
          </Alert>
        </Flex>
      )}
      {getCodSituacaoPubli === 6 && (
        <Flex justifyContent="end">
          <Alert status="warning" mt="35px" borderRadius="md">
            <AlertIcon />
            <Box flex="1">
              <AlertTitle fontSize="lg" mb={1}>Publicação Reprovada</AlertTitle>
              <AlertDescription display="block">
                Após revisão, sua publicação não obteve aprovação.{' '}
                <Button variant="link" colorScheme="blue" onClick={mostrarMotivoReprovacao}>
                  Clique aqui para ver os motivos.
                </Button>
              </AlertDescription>
            </Box>
          </Alert>
        </Flex>
      )}
      {isLoading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (

        <Box m="40px 0" w="100%">
          <form onSubmit={handleFormSubmit}>
            <div className="row">
              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.seqCategoria.error}>
                  <FormLabel mb="8px">Categoria do Evento</FormLabel>
                  <Select
                    placeholder='Selecione uma Categoria'
                    borderColor="gray.300"
                    _hover={{ borderColor: 'blue.500' }}
                    value={formValues.seqCategoria.value}
                    onChange={(e) => handleFieldChange('seqCategoria', e.target.value)}
                  >
                    {categorias.length > 0 ? (
                      categorias.map(categoria => (
                        <option key={categoria.seqCategoria} value={categoria.seqCategoria}>
                          {categoria.dscCategoria}
                        </option>
                      ))
                    ) : (
                      <option disabled>Sem categorias disponíveis</option>
                    )}
                  </Select>
                </FormControl>
              </div>

              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.titulo.error}>
                  <FormLabel mb="8px">Título do Evento</FormLabel>
                  <CustomInput
                    placeholder="Digite um título"
                    value={formValues.titulo.value}
                    onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                  />
                </FormControl>
              </div>

              <div className="col-md-6 mb-4">
                <FormControl mb={'24px'}>
                  <FormLabel mb="8px">Endereço do Evento</FormLabel>
                  <CustomInput
                    placeholder="Digite um endereço"
                    value={formValues.endereco.value}
                    onChange={(e) => handleFieldChange('endereco', e.target.value)}
                  />
                </FormControl>

                <div className="row" style={{ marginBottom: '24px' }}>
                  <div className="col-md-6">
                    <FormControl isRequired>
                      <FormLabel mb="8px">Data início do evento</FormLabel>
                      <CustomInput
                        id="event-start-date"
                        type="date"
                        value={formValues.dataInicioEvento.value}
                        onChange={(e: any) => handleFieldChange('dataInicioEvento', e.target.value)}
                      />
                    </FormControl>
                  </div>

                  <div className="col-md-6">
                    <FormControl>
                      <FormLabel mb="8px">Data fim do evento</FormLabel>
                      <CustomInput
                        id="event-end-date"
                        type="date"
                        value={formValues.dataFimEvento.value}
                        onChange={(e) => handleFieldChange('dataFimEvento', e.target.value)}
                      />
                    </FormControl>
                  </div>
                </div>
                <Stack spacing={4} mb='24px'>
                <FormControl display="flex" alignItems="center">
                <Switch
                  id="dia-todo"
                  isChecked={formValues.numSemHorario.value}
                  onChange={e => {
                    const isChecked = e.target.checked;

                    setFormValues(prev => ({
                      ...prev,
                      numSemHorario: { value: isChecked, error: false },
                      horaInicioEvento: { value: isChecked ? '' : prev.horaInicioEvento.value, error: false },
                      horaFimEvento: { value: isChecked ? '' : prev.horaFimEvento.value, error: false }
                    }));
                  }}
                />

                  <FormLabel htmlFor="dia-todo" mb="0" ml="8px">
                    Evento o dia todo
                  </FormLabel>
                </FormControl>

                <HStack spacing={6} width="100%">
                  <FormControl flex="1" isRequired={!formValues.numSemHorario.value}>
                    <FormLabel mb="8px">Horário de início</FormLabel>
                    <CustomInput
                      type="time"
                      value={formValues.horaInicioEvento.value}
                      isDisabled={formValues.numSemHorario.value}
                      onChange={e =>
                        handleFieldChange('horaInicioEvento', e.target.value)
                      }
                    />
                  </FormControl>

                  <FormControl flex="1" isRequired={!formValues.numSemHorario.value}>
                    <FormLabel mb="8px">Horário de término</FormLabel>
                    <CustomInput
                      type="time"
                      value={formValues.horaFimEvento.value}
                      isDisabled={formValues.numSemHorario.value}
                      onChange={e =>
                        handleFieldChange('horaFimEvento', e.target.value)
                      }
                    />
                  </FormControl>
                </HStack>
              </Stack>

                <div className="col-md-12 mb-4">
                  <FormControl className='mb-4'>
                    <FormLabel mb="8px">Imagem miniatura</FormLabel>
                    <ImageDropzone
                      base64={imagePreview}
                      onImageSelected={handleImageSelected}
                      uploadMessage="Arraste ou selecione uma imagem"
                      height={300}
                      />
                    <input
                      id="image-upload"
                      type="file"
                      style={{ display: 'none' }}
                      accept="image/jpeg, image/png"
                      onChange={(e) => handleImageSelected(e.target.files ? e.target.files[0] : null)}
                    />

                    {temImagem && (
                      <>
                        <FormControl isRequired className="mt-3">
                          <FormLabel mb="8px">Crédito/Autor da imagem</FormLabel>
                          <CustomInput
                            placeholder="Digite um crédito ou autor da imagem"
                            value={formValues.creditoAutorImagem.value}
                            onChange={(e) => handleFieldChange('creditoAutorImagem', e.target.value)}
                          />
                        </FormControl>

                        <FormControl className="mt-3">
                          <FormLabel mb="8px">Descrição de imagem</FormLabel>
                          <CustomInput
                            placeholder="Digite o texto alternativo da imagem"
                            value={formValues.altImagem.value}
                            onChange={(e) => handleFieldChange('altImagem', e.target.value)}
                          />
                        </FormControl>

                        <FormControl className="mt-3">
                          <FormLabel mb="8px">Descrição adicional da imagem</FormLabel>
                          <CustomInput
                            placeholder="Digite uma descrição adicional da imagem"
                            value={formValues.descricaoImagem.value}
                            onChange={(e) => handleFieldChange('descricaoImagem', e.target.value)}
                          />
                        </FormControl>
                      </>
                    )}

                  </FormControl>

                  <input
                    id="image-upload"
                    type="file"
                    style={{ display: 'none' }}
                    accept="image/jpeg, image/png"
                    onChange={(e) => handleImageSelected(e.target.files ? e.target.files[0] : null)}
                  />
                </div>

                <FormControl mt={'24px'}>
                  <Flex justify="space-between" align="center" mb="8px">
                    <FormLabel mb="8px">
                      Escolha em quais páginas a Evento deve aparecer <span style={{ color: 'red' }}>*</span>
                    </FormLabel>
                  </Flex>
                  <div className="sidebar-checkbox-pagina">
                    <Stack spacing={5}>
                      {paginas.length > 0 ? (
                        paginas.map((pagina: any) => (
                          <Flex key={pagina.seqPagina} align="center" justify="space-between" direction={{ base: 'column', md: 'row' }}>
                            <Checkbox
                              className="checkPaginasNoticia"
                              isChecked={formValues.paginaId.value.includes(pagina.seqPagina.toString())}
                              onChange={(e) => handleCheckboxChange(pagina.seqPagina, e)}
                            >
                              {pagina.nomPagina}
                            </Checkbox>
                          </Flex>
                        ))
                      ) : (
                        <p>Não há páginas disponíveis.</p>
                      )}
                    </Stack>
                  </div>
                </FormControl>
              </div>

              <Box className='col-md-6'>
                <div className='row'>
                  <div className="col-md-6 mb-4">
                    <FormControl isRequired>
                      <FormLabel mb="8px">Data para Publicação</FormLabel>
                      <CustomInput
                        id="event-publication-date"
                        type="date"
                        value={formValues.data.value}
                        onChange={(e) => handleFieldChange('data', e.target.value)}
                      />
                    </FormControl>
                  </div>
                  <div className="col-md-6 mb-4">
                    <FormControl>
                      <FormLabel mb="8px">Data fim para Publicação</FormLabel>
                      <CustomInput
                        id="event-unpublish-date"
                        type="date"
                        value={formValues.dataFim.value}
                        onChange={(e) => handleFieldChange('dataFim', e.target.value)}
                        min={today}
                      />
                    </FormControl>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 mb-4">
                    <FormControl>
                      <FormLabel mb="8px">Resumo do evento</FormLabel>
                      <CustomTextArea
                        placeholder="Digite um resumo"
                        value={formValues.dscResumo.value}
                        onChange={(e) => handleFieldChange('dscResumo', e.target.value)}
                      />
                    </FormControl>
                  </div>
                </div>

                <FormControl>
                  <FormLabel mb="8px">Tags</FormLabel>
                  <div style={{ display: 'flex' }}>
                    <CustomInput
                      value={inputValueTagUsuario}
                      onChange={handleInputChangeTagUsuario}
                      placeholder="Digite uma tag"
                      maxLength={100}
                    />
                    <Button onClick={handleAddTagUsuario} ml="2">
                      <FaPlus />
                    </Button>
                  </div>
                </FormControl>
                <div className="rolagem-hashtag mb-2">
                  <Wrap spacing="2px">
                    {tagUsuario?.trim() &&
                      tagUsuario.split(' ').map((tag, index) => (
                        <WrapItem key={index}>
                          <Tag variant="solid" colorScheme="blue" maxW="180px" isTruncated>
                            <TagLabel>{tag}</TagLabel>
                            <TagCloseButton onClick={() => handleRemoveTagUsuario(tag)} />
                          </Tag>
                        </WrapItem>
                      ))}
                  </Wrap>
                </div>
                <FormControl marginBottom={'24px'}>
                  <FormLabel mb="8px">Endereço de Internet para o evento</FormLabel>
                  <CustomInput
                    placeholder="Digite um endereço de internet"
                    value={formValues.enderecoInternet.value}
                    onChange={(e) => handleFieldChange('enderecoInternet', e.target.value)}
                  />
                </FormControl>

                <FormControl className='mb-4 mt-1'>
              {secretarias.length > 0 && (
                <>
                  <Flex justify="space-between" align="center">
                    <FormLabel mb="8px">
                      Associe o usuário a uma secretaria (opcional)
                    </FormLabel>
                  </Flex>

                  <Box
                    border="1px solid"
                    borderColor="gray.300"
                    borderRadius="md"
                    p={3}
                  >
                    <Box overflow="hidden">
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                          <col style={{ width: '60px' }} />
                          <col style={{ width: '120px' }} />
                          <col />
                        </colgroup>
                        <thead>
                          <tr>
                            <th style={{ textAlign:'center', padding:'8px', borderBottom:'1px solid #ddd' }}></th>
                            <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Código</th>
                            <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Secretaria</th>
                          </tr>
                        </thead>
                      </table>
                    </Box>

                    <Box 
                      className="sidebar-checkbox-pagina"
                      overflowX="auto"
                      overflowY={secretarias.length > 5 ? 'auto' : 'visible'}
                      maxH={secretarias.length > 5 ? '240px' : 'unset'}
                    >
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                          <col style={{ width: '60px' }} />
                          <col style={{ width: '120px' }} />
                          <col />
                        </colgroup>
                        <tbody>
                        {secretarias.map((secretaria: any) => {
                          const cod = Number(secretaria.codSecretaria);
                          const nome = secretaria.secretariasDTO?.dscSecretaria ?? secretaria.dscSecretaria ?? '—';

                          return (
                            <tr key={cod}>
                              <td style={{ textAlign: "center", padding: "8px", borderBottom: "1px solid #ddd" }}>
                                <Checkbox
                                  className="checkCategorias"
                                  isChecked={secretariaSelecionada.includes(cod)}
                                  onChange={(e) => handleCheckboxSecretaria(cod, e.target.checked)}
                                />
                              </td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{cod}</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{nome}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                      </table>
                    </Box>
                  </Box>
                </>
              )}
            </FormControl>

                {/* <div className="row mt-2">
                  <div className="col-md-6 mb-4">
                    <FormControl isRequired>
                      <FormLabel mb="8px">Exige aprovação</FormLabel>
                      <RadioGroup
                        mt={3.5}
                        onChange={(value) => handleInputRadioChange('exigeAprovacao', Number(value))}
                        value={formValues.exigeAprovacao.value.toString()}
                      >
                        <Radio value="1" mr={5}>Sim</Radio>
                        <Radio value="0">Não</Radio>
                      </RadioGroup>
                    </FormControl>
                  </div>

                  {formValues.exigeAprovacao.value === 1 && (
                    <div className="col-md-6 mb-4">
                      <FormControl isRequired>
                        <FormLabel mb="8px">Selecione o aprovador desta publicação</FormLabel>
                        <div className={`input-radio-lista ${aprovadores.length === 0 ? 'escondida' : ''}`}>
                          <Stack spacing={5}>
                            {aprovadores.length > 0 ? (
                              aprovadores.map((aprovador: any) => (
                                <Flex key={aprovador.seqUsuario} align="center" justify="space-between" direction="row">
                                  <Radio
                                    value={aprovador.seqUsuario.toString()}
                                    isChecked={selectedUser === aprovador.seqUsuario}
                                    onChange={(e) => handleRadioChange(aprovador.seqUsuario, e)}
                                  >
                                    {aprovador.dscNome}
                                  </Radio>
                                </Flex>
                              ))
                            ) : (
                              <p>Não há lista de aprovadores disponíveis.</p>
                            )}
                          </Stack>
                        </div>
                      </FormControl>
                    </div>
                  )}
                </div> */}
              </Box>
            </div>

            <Flex hidden={isAtivo == 0} mt="35px" justifyContent="end">
              <Button
                m="6px"
                onClick={() => navigate(-1)}
              >
                Desistir
              </Button>
              <Button
                type="submit"
                m="6px"
                color="#FFF"
                bgColor="#1665D8"
                _hover={{ opacity: 0.8 }}
                isDisabled={!isFormValid()}
                isLoading={isLoadingButton}
                loadingText="Editando Evento..."
              >
                {getCodSituacaoPubli == 6
                ? 'Reenviar para Aprovação'
                : 'Editar Evento'}     
              </Button>
              <Button
                hidden={isAtivo == 0}
                onClick={() => inativarPublicacao()}
                m="6px"
                color="white"
                bgColor="red.500"
                _hover={{ bg: "red.600" }}
              >
                Inativar Publicação Imediatamente
              </Button>
            </Flex>
            {isAtivo == 0 && (
              <Flex mt="35px" justifyContent="end">
                <Button
                  color="#FFF"
                  bgColor="#1665D8"
                  m="6px"
                  onClick={() => navigate(-1)}
                >
                  Voltar
                </Button>
              </Flex>
            )}
          </form>
        </Box>
      )}
    </Flex>
  );
};

export default EditarEvento;
